export const TRANSLATION_KEYS = {
    Heading: "common.columnsRefinementDrawer.heading",
    ConfirmText: "common.applyText"
};